import { Routes } from '@angular/router';

import { AdminAuthGuard, AttendantAuthGuard } from './services/auth-guards.service';

export const routes: Routes = [
  {
    path: 'Home',
    loadComponent: () => import('./pages/home/home.page').then(m => m.HomePage),
    data: { breadcrumb: 'breadcrumb_Home' },
  },
  {
    path: 'Admin/Attendants',
    canActivate: [AdminAuthGuard],
    loadComponent: () =>
      import('./pages/admin/admin-attendants/admin-attendants.page').then(m => m.AdminAttendantsPage),
  },
  {
    path: 'Admin/Accounts',
    canActivate: [AdminAuthGuard],
    loadComponent: () => import('./pages/admin/admin-accounts/admin-accounts.page').then(m => m.AdminAccountsPage),
  },
  {
    path: 'Search',
    loadComponent: () => import('./pages/search/attendant-search.page').then(m => m.AttendantSearchPage),
    data: { breadcrumb: 'breadcrumb_SearchResults' },
  },
  {
    path: 'Attendant',
    loadComponent: () =>
      import('./pages/attendant/attendant-profile/attendant-profile.page').then(m => m.AttendantProfilePage),
    data: { breadcrumb: 'breadcrumb_AttendantProfile' },
  },
  {
    path: 'Attendant/Edit',
    canActivate: [AttendantAuthGuard],
    loadComponent: () =>
      import('./pages/attendant/attendant-profile-edit/attendant-profile-edit.page').then(
        m => m.AttendantProfileEditPage
      ),
    data: { breadcrumb: 'breadcrumb_EditProfile' },
  },
  {
    path: 'Attendant/Affirm',
    loadComponent: () =>
      import('./pages/attendant/attendant-affirm/attendant-affirm.page').then(m => m.AttendantAffirmPage),
  },
  {
    path: 'Attendant/Reaffirm/:id',
    loadComponent: () =>
      import('./pages/attendant/attendant-reaffirm/attendant-reaffirm.page').then(m => m.AttendantReaffirmPage),
  },
  {
    path: 'Login',
    loadComponent: () => import('./pages/login/login.page').then(m => m.LoginPage),
  },
  {
    path: 'Register',
    loadComponent: () => import('./pages/register/register.page').then(m => m.RegisterPage),
  },
  {
    path: 'Requirements',
    loadComponent: () => import('./pages/requirements/requirements.page').then(m => m.RequirementsPage),
  },
  {
    path: '',
    loadComponent: () => import('./pages/home/home.page').then(m => m.HomePage),
  },
];
